// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const beartic: PokeData = {
  "id": 614,
  "name": "beartic",
  "height": 26,
  "weight": 2600,
  "base_experience": 177,
  "types": [
    PokeType.ICE
  ],
  "api_moves": [
    "thrash",
    "growl",
    "blizzard",
    "bide",
    "fury-swipes",
    "rest",
    "slash",
    "flail",
    "powder-snow",
    "icy-wind",
    "endure",
    "charm",
    "swagger",
    "hail",
    "superpower",
    "sheer-cold",
    "brine",
    "aqua-jet",
    "frost-breath",
    "icicle-crash",
    "play-nice",
    "snowscape"
  ],
  "moves": [
    "growl",
    "blizzard",
    "superpower",
    "sheer-cold",
    "brine",
    "aqua-jet",
    "icicle-dagger",
    "ice-shard",
    "ice-wave",
    "hailstorm",
    "chilly-reception",
    "ice-fang",
    "aurora-veil"
  ],
  "evolution_chain": {
    "id": 310,
    "item": null,
    "species": [
      {
        "name": "cubchoo",
        "order": 614,
        "types": [
          PokeType.ICE
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "beartic",
        "order": 615,
        "types": [
          PokeType.ICE
        ],
        "evolves_from_species_id": 613,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 37,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 131,
    "speed": 75,
    "ability_power": 194
  },
  "stat_changes": [],
  "catch_rate": 60,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
